// extracted by mini-css-extract-plugin
export default {"fr-view":"FinderGAR_fr-view__xx7bp","group":"FinderGAR_group__cXxHQ"};